import { createAsyncThunk } from '@reduxjs/toolkit';

import { log } from '../../../services/logging';
import { getFullScene } from '../../../services/scene';
import type { Scene } from '../../../types/scene';
import type { Nullable } from '../../../types/utility';
import { isPerspectiveSharingAvailable } from '../../connections/connectionsDuck';
import { isSharedStorageAvailable, sharedStorageApi } from '../../shared-storage/shared-storage.api';
import type { RootState } from '../../types';
import { NAME } from './const';

export const fetchSceneThunk = createAsyncThunk<Nullable<Scene> | undefined, { sceneId: string }, { state: RootState }>(
  `${NAME}/fetchSceneThunk`,
  async ({ sceneId }, { dispatch, getState }) => {
    const state = getState();
    const isPluginPresent = isPerspectiveSharingAvailable(state);

    try {
      if (isPluginPresent) {
        return await getFullScene(sceneId);
      } else if (isSharedStorageAvailable()) {
        const { data } = await dispatch(sharedStorageApi.endpoints.getScene.initiate({ sceneId }));

        if (!data) {
          throw new Error('Scene not found in shared storage.');
        }

        return data;
      }
    } catch (error) {
      log.error(`Scene ${sceneId} could not be loaded:`, error);
    }
  },
);
